import React, { useEffect, useRef, useState } from "react";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import "./benefits.css";
import benefitImage1 from "../../../images/Agent Trust Images/assets/BenefitsSection/Reliable AI Deployments.svg";
import benefitImage2 from "../../../images/Agent Trust Images/assets/BenefitsSection/Regulatory Compliance.svg";
import benefitImage3 from "../../../images/Agent Trust Images/assets/BenefitsSection/Bias-Free Decision-Making.svg";
import benefitImage4 from "../../../images/Agent Trust Images/assets/BenefitsSection/Data Security & Privacy.svg";
import benefitImage5 from "../../../images/Agent Trust Images/assets/BenefitsSection/Business Continuity.svg";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
export default function Benefits() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const cardWrapperRef = useRef(null);
  const [isLeftDisabled, setIsLeftDisabled] = useState(true);
  const [isRightDisabled, setIsRightDisabled] = useState(false);
  const benefitPoints = [
    {
      heading: "Reliable AI Deployments",
      paragraph: "Reduce risk with validated AI trust scores ",
      img: benefitImage1,
    },
    {
      heading: "Regulatory Compliance ",
      paragraph: "Meet industry standards with AI monitoring ",
      img: benefitImage2,
    },
    {
      heading: "Bias-Free Decision-Making ",
      paragraph: "Ensure AI models operate ethically and fairly ",
      img: benefitImage3,
    },
    {
      heading: "Data Security & Privacy",
      paragraph: "Strengthen AI safeguards against vulnerabilities ",
      img: benefitImage4,
    },
    {
      heading: "Business Continuity",
      paragraph: "Detect AI risks before they impact operations",
      img: benefitImage5,
    },
  ];
  useEffect(() => {
    const cardWrapper = cardWrapperRef.current;
    const updateButtonVisibility = () => {
      if (!cardWrapper) return;
      const currentScroll = cardWrapper.scrollLeft;
      const maxScroll = cardWrapper.scrollWidth - cardWrapper.clientWidth;

      setIsLeftDisabled(currentScroll <= 0);
      setIsRightDisabled(currentScroll >= maxScroll);
    };

    updateButtonVisibility();
    cardWrapper.addEventListener("scroll", updateButtonVisibility);
    window.addEventListener("resize", updateButtonVisibility);

    return () => {
      cardWrapper.removeEventListener("scroll", updateButtonVisibility);
      window.removeEventListener("resize", updateButtonVisibility);
    };
  }, []);

  const handleScroll = (direction) => {
    const cardWrapper = cardWrapperRef.current;
    if (!cardWrapper) return;
    const cardWidth = cardWrapper.children[0].offsetWidth + 20;
    cardWrapper.style.scrollBehavior = "smooth";
    cardWrapper.scrollLeft += direction === "left" ? -cardWidth : cardWidth;
  };

  return (
    <section
      className={`benefits-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="five"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Benefits</span>
          </div>
          <div className="heading-description">
            <h2>Strengthening AI Trust for Reliable Decision-Making</h2>
            <p>
              Leverage AI Trust Score to improve AI governance, compliance, and
              transparency.
            </p>
          </div>
        </div>
        <div
          className="benefit-sliding-cards-wrapper"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              e.preventDefault(); // Prevent selection when clicking on empty space
            }
          }}
        >
          <div
            className={`previous-slide-btn ${isLeftDisabled ? "disabled" : ""}`}
            onClick={() => handleScroll("left")}
          >
            <FaArrowLeft color="#fff" stroke="#fff" />
          </div>
          <div className="benefit-cards-wrapper" ref={cardWrapperRef}>
            {benefitPoints.map((benefit, index) => (
              <div key={index} className="benefit-card-outer">
                <div className="benefit-card">
                  <h3>{benefit.heading}</h3>
                  <p>{benefit.paragraph}</p>
                  <img
                    src={benefit.img}
                    alt={benefit.heading}
                    className="benefit-image"
                  />
                </div>
              </div>
            ))}
          </div>
          <div
            className={`next-slide-btn ${isRightDisabled ? "disabled" : ""}`}
            onClick={(e) => {
              if (isRightDisabled) {
                e.stopPropagation(); // Prevent click from affecting other elements
                return;
              }
              handleScroll("right");
            }}
          >
            <FaArrowRight color="#fff" stroke="#fff" />
          </div>
        </div>
      </div>
    </section>
  );
}
